import React from 'react';

const AuthSkeleton: React.FC = () => (
  <div
    role="status"
    aria-busy="true"
    aria-label="Loading your account"
    className="flex items-center gap-2"
  >
    <span className="sr-only">Loading your account</span>
    <div className="h-8 w-[114px] animate-pulse rounded-lg bg-[var(--color-primary)]/25" />
    <div className="flex h-12 items-center gap-3 rounded-md bg-amber-50 px-1 py-1">
      <div className="h-10 w-10 shrink-0 animate-pulse rounded-full bg-black/10" />
      <div className="flex w-[7rem] flex-col gap-1.5 xl:w-[11rem]">
        <div className="h-3 w-full animate-pulse rounded bg-black/10" />
        <div className="hidden h-2.5 w-3/4 animate-pulse rounded bg-black/[0.07] xl:block" />
      </div>
      <div className="ml-1 h-[18px] w-[18px] shrink-0 animate-pulse rounded bg-black/[0.07]" />
    </div>
  </div>
);

export default AuthSkeleton;
